import { useEffect, useState } from "react";
import { DURATION, notify, TYPE } from "@8x8/oxygen-toaster";

export const displayToastMessage = (message, options) => {
  const defaultOptions = {
    type: TYPE.error,
    content: message,
    duration: DURATION.INFINITE,
  };
  const mergedOptions = { ...defaultOptions, ...options };
  return notify(mergedOptions);
};

export function useDismissableNotification(message, options = {}) {
  const [toast, setToast] = useState(undefined);

  useEffect(() => {
    if (!message) {
      if (toast) {
        toast.close();
        setToast(undefined);
      }
      return;
    }
    setToast(displayToastMessage(message, options));
  }, [message, JSON.stringify(options)]);

  return toast;
}
